import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { MyApplicationsService } from '@app/pages/my-application/my-app-service.service';

export interface EducatorDuplicateDocumentAuditParams {
  personId: number;
  screenName: string;
  fileName: string;
  categoryKey: string;
  typeKey?: string;
  categoryDisplay?: string;
  typeDisplay?: string;
}

@Injectable({ providedIn: 'root' })
export class EducatorDuplicateDocumentAuditService {
  constructor(private readonly myAppService: MyApplicationsService) {}

  logDuplicateDetected(params: EducatorDuplicateDocumentAuditParams): void {
    let performedBy: number | null = null;
    try {
      const userRaw = sessionStorage.getItem('user');
      if (userRaw) {
        const user = JSON.parse(userRaw);
        const id = user?.user_id ?? user?.id ?? user?.userId ?? null;
        performedBy = id != null ? Number(id) : null;
      }
    } catch {
      performedBy = null;
    }

    const categoryName = params.categoryDisplay?.trim() || params.categoryKey;
    const docTypeName = params.typeDisplay?.trim() || params.typeKey || '';

    const auditLogData = {
      person_id: params.personId,
      action: 'DUPLICATE_FILE_ERROR',
      screen_name: params.screenName,
      field_name: categoryName,
      performed_by: performedBy,
      changes: JSON.stringify({
        error_type: 'Duplicate File',
        file_name: params.fileName,
        category: categoryName,
        document_type: docTypeName,
        error_message: 'File exists with same name, category and type',
        timestamp: new Date().toISOString()
      })
    };

    this.myAppService
      .uploadDocumentLog(auditLogData)
      .pipe(take(1))
      .subscribe({
        error: () => {
          /* non-blocking */
        }
      });
  }
}
